import React from "react";

export default function DownloadWhite({ id, style }) {
    return <svg id={id} width="13" height="13" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path d="M7.21875 9.09375L10.5 12.375L13.7812 9.09375" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.5 3.625V12.375" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.375 12.375V16.75C17.375 16.9158 17.3092 17.0747 17.1919 17.1919C17.0747 17.3092 16.9158 17.375 16.75 17.375H4.25C4.08424 17.375 3.92527 17.3092 3.80806 17.1919C3.69085 17.0747 3.625 16.9158 3.625 16.75V12.375" stroke="white" stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>;
}


// WEBPACK FOOTER //
// ./src/rifa/components/layout/icons/downloadWhite.jsx